import React from "react";
import { AppBar, Toolbar, Typography } from "@mui/material";
import { logoHeaderImage } from "assets";
import { HEADER } from "../../../constants";

const Header: React.FC = () => {
  return (
    <AppBar
      position="static"
      sx={{
        paddingTop: 1,
        paddingBottom: 1,
        backgroundColor: "var(--color-background)",
        borderBottom: "1px solid var(--color-border)",
        boxShadow: "none",
      }}
    >
      <Toolbar
        sx={{
          minHeight: "var(--spacing-xxl) !important",
          paddingX: "var(--spacing-lg)",
        }}
      >
        <img
          src={logoHeaderImage}
          alt="logo"
          style={{
            marginRight: "var(--spacing-md)",
            height: "var(--spacing-xl)",
            transition: "filter var(--transition-fast)",
          }}
        />
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            color: "var(--color-text-primary)",
            fontFamily: "var(--font-family-primary)",
            fontSize: "var(--font-size-lg)",
            fontWeight: "var(--font-weight-medium)",
          }}
        >
          {HEADER}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
